// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Muted slate–blue palette (no pure white) for less glare */
.login-container {
  display: flex;
  flex-direction: column;
  min-height: 100dvh;
  min-height: 100vh;
  background: linear-gradient(160deg, #dce6ee 0%, #e8eef3 45%, #dfe8ef 100%);
  font-family: "Segoe UI", sans-serif;
  gap: 0;
}

/* Marketing panel: below form on narrow screens */
.left-card {
  order: 2;
  flex: 1 1;
  padding: clamp(1.25rem, 4vw, 2.5rem);
  background: linear-gradient(180deg, #eef2f6 0%, #e6ecf2 100%);
  color: #1c2d38;
  border-radius: 0 0 12px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35);
}

.welcome-title {
  font-size: clamp(1.15rem, 3.5vw, 1.75rem);
  line-height: 1.35;
  margin-bottom: clamp(1rem, 3vw, 2rem);
  font-weight: 700;
  text-align: center;
  color: #153448;
}

.mvf-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: clamp(0.75rem, 2vw, 1.5rem);
}

@media (min-width: 520px) {
  .mvf-grid {
    grid-template-columns: 1fr 1fr;
  }
}

.mvf-box {
  padding: clamp(1rem, 2.5vw, 1.5rem);
  border-radius: 12px;
  color: #243848;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 18px rgba(21, 52, 72, 0.12);
  min-width: 0;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.mvf-box h2 {
  display: flex;
  align-items: center;
  font-size: clamp(1.1rem, 2.8vw, 1.5rem);
  margin-bottom: 0.75rem;
  color: #153448;
  font-weight: 600;
}

.mvf-icon {
  margin-right: 8px;
  flex-shrink: 0;
  color: #1a3a4d;
}

.mvf-box ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.mvf-box li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 0.5rem;
  font-size: clamp(0.85rem, 2.2vw, 1.05rem);
  line-height: 1.35;
  color: #2c3e4a;
}

.bullet-icon {
  color: #3d5a6e;
  flex-shrink: 0;
  margin-top: 0.15em;
}

.mvf-box.mission {
  background: linear-gradient(135deg, #5f7aad, #a8b9d4);
}

.mvf-box.vision {
  background: linear-gradient(135deg, #4abee8, #d4e8f2);
}

.mvf-box.focus {
  background: linear-gradient(135deg, #d8e6f2, #5a94e8);
}

.mvf-box.contribution {
  background: linear-gradient(135deg, #8670d4, #e4dff2);
}

/* Login panel: first on mobile */
.right-login-box {
  order: 1;
  flex: 1 1;
  padding: clamp(1.5rem, 5vw, 3rem) clamp(1.25rem, 4vw, 2rem);
  background: linear-gradient(145deg, #7eb8d4 0%, #6aa8c8 40%, #5c96b8 100%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  border-radius: 12px 12px 0 0;
  box-shadow: 0 4px 28px rgba(28, 60, 80, 0.18);
  min-width: 0;
  animation: fadeIn 1.2s ease-in;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.login-title {
  font-size: clamp(1.5rem, 5vw, 2.25rem);
  margin: 0 0 clamp(1.25rem, 3vw, 2rem);
  color: #0c2f3d;
  font-weight: 700;
  text-align: center;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2);
}

.login-form {
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
}

.login-form input {
  width: 100%;
  box-sizing: border-box;
}

.login-form .login-button {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-left: 0;
}

.login-form label {
  font-weight: 600;
  margin-bottom: 0.6rem;
  display: block;
  color: #2a4150;
  font-size: clamp(1rem, 2.5vw, 1.25rem);
}

.login-form .form-field {
  margin-bottom: 1rem;
}

.login-form .form-field:last-of-type {
  margin-bottom: 1.25rem;
}

.login-form input[type="email"],
.login-form input[type="password"],
.login-form input[type="text"] {
  padding: 0.85rem 1rem;
  border: 1px solid rgba(12, 47, 61, 0.18);
  border-radius: 10px;
  font-size: clamp(1rem, 2.5vw, 1.15rem);
  background-color: rgba(255, 255, 255, 0.72);
  color: #1c2d38;
  box-shadow: inset 0 1px 3px rgba(12, 47, 61, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.login-form input::placeholder {
  color: #5a7282;
}

.login-form input:focus {
  border-color: rgba(0, 120, 168, 0.55);
  background-color: rgba(255, 255, 255, 0.9);
  box-shadow: 0 0 0 3px rgba(0, 136, 198, 0.22);
  outline: none;
}

/* Grid stacks input + button in one row so the icon stays centered without transform */
.password-field {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  margin-bottom: 0;
}

.password-field input {
  grid-column: 1;
  grid-row: 1;
  padding-right: 2.75rem;
  margin-bottom: 0;
  min-width: 0;
}

.password-toggle {
  grid-column: 1;
  grid-row: 1;
  justify-self: end;
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  margin-right: 0.35rem;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #0c2f3d;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.password-toggle:hover {
  background: rgba(12, 47, 61, 0.12);
  color: #061f28;
}

.password-toggle:focus-visible {
  outline: 2px solid #0088c6;
  outline-offset: 1px;
}

.login-button {
  padding: 0.9rem 1.25rem;
  background: linear-gradient(180deg, #0a7aad 0%, #066892 100%);
  color: #f0f6f9;
  border: none;
  border-radius: 10px;
  font-size: clamp(1.05rem, 2.5vw, 1.2rem);
  font-weight: 700;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 16px rgba(6, 60, 82, 0.35);
  margin-top: 0.25rem;
}

.login-button:hover {
  background: linear-gradient(180deg, #096a94 0%, #055a7d 100%);
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(6, 60, 82, 0.4);
}

.login-button:active {
  transform: translateY(0);
}

.error-message {
  color: #c62828;
  margin-top: -0.35rem;
  margin-bottom: 0.5rem;
  font-size: clamp(0.8rem, 2vw, 0.95rem);
}

.footer-logos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  gap: clamp(1rem, 3vw, 2rem);
  padding-top: clamp(1rem, 3vw, 2rem);
}

.footer-logos img {
  height: clamp(56px, 12vw, 90px);
  max-width: 45%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.footer-logos img:hover {
  transform: scale(1.05);
}

.forgot-password-link {
  text-align: right;
}

.forgot-password-link a {
  font-size: 1.4rem;
  color: #005580;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.forgot-password-link a:hover {
  color: #003f5c;
  text-decoration: underline;
}

/* Side-by-side layout on large screens */
@media (min-width: 960px) {
  .login-container {
    flex-direction: row;
    align-items: stretch;
    gap: 0;
  }

  .left-card {
    order: 1;
    flex: 1 1;
    border-radius: 12px 0 0 12px;
    padding: 2.5rem;
  }

  .right-login-box {
    order: 2;
    flex: 1 1;
    max-width: min(520px, 48vw);
    border-radius: 0 12px 12px 0;
    align-items: center;
    box-shadow: -5px 0 30px rgba(0, 0, 0, 0.05);
  }

  .login-title {
    text-align: left;
    align-self: stretch;
    max-width: 380px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/login.css"],"names":[],"mappings":"AAAA,4DAA4D;AAC5D;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,0EAA0E;EAC1E,mCAAmC;EACnC,MAAM;AACR;;AAEA,kDAAkD;AAClD;EACE,QAAQ;EACR,SAAO;EACP,oCAAoC;EACpC,6DAA6D;EAC7D,cAAc;EACd,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,6CAA6C;EAC7C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,iCAAiC;AACjC;EACE,QAAQ;EACR,SAAO;EACP,2DAA2D;EAC3D,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,6CAA6C;EAC7C,YAAY;EACZ,8BAA8B;EAC9B,kDAAkD;AACpD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;EACnB,sCAAsC;EACtC,2CAA2C;EAC3C,cAAc;EACd,kDAAkD;EAClD,oFAAoF;AACtF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,6CAA6C;EAC7C,aAAa;AACf;;AAEA,uFAAuF;AACvF;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,2EAA2E;EAC3E,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,yCAAyC;AACzC;EACE;IACE,mBAAmB;IACnB,oBAAoB;IACpB,MAAM;EACR;;EAEA;IACE,QAAQ;IACR,SAAO;IACP,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,QAAQ;IACR,SAAO;IACP,2BAA2B;IAC3B,4BAA4B;IAC5B,mBAAmB;IACnB,2CAA2C;EAC7C;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":["/* Muted slate–blue palette (no pure white) for less glare */\n.login-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100dvh;\n  min-height: 100vh;\n  background: linear-gradient(160deg, #dce6ee 0%, #e8eef3 45%, #dfe8ef 100%);\n  font-family: \"Segoe UI\", sans-serif;\n  gap: 0;\n}\n\n/* Marketing panel: below form on narrow screens */\n.left-card {\n  order: 2;\n  flex: 1;\n  padding: clamp(1.25rem, 4vw, 2.5rem);\n  background: linear-gradient(180deg, #eef2f6 0%, #e6ecf2 100%);\n  color: #1c2d38;\n  border-radius: 0 0 12px 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.35);\n}\n\n.welcome-title {\n  font-size: clamp(1.15rem, 3.5vw, 1.75rem);\n  line-height: 1.35;\n  margin-bottom: clamp(1rem, 3vw, 2rem);\n  font-weight: 700;\n  text-align: center;\n  color: #153448;\n}\n\n.mvf-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: clamp(0.75rem, 2vw, 1.5rem);\n}\n\n@media (min-width: 520px) {\n  .mvf-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.mvf-box {\n  padding: clamp(1rem, 2.5vw, 1.5rem);\n  border-radius: 12px;\n  color: #243848;\n  backdrop-filter: blur(8px);\n  box-shadow: 0 4px 18px rgba(21, 52, 72, 0.12);\n  min-width: 0;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.mvf-box h2 {\n  display: flex;\n  align-items: center;\n  font-size: clamp(1.1rem, 2.8vw, 1.5rem);\n  margin-bottom: 0.75rem;\n  color: #153448;\n  font-weight: 600;\n}\n\n.mvf-icon {\n  margin-right: 8px;\n  flex-shrink: 0;\n  color: #1a3a4d;\n}\n\n.mvf-box ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.mvf-box li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 0.5rem;\n  font-size: clamp(0.85rem, 2.2vw, 1.05rem);\n  line-height: 1.35;\n  color: #2c3e4a;\n}\n\n.bullet-icon {\n  color: #3d5a6e;\n  flex-shrink: 0;\n  margin-top: 0.15em;\n}\n\n.mvf-box.mission {\n  background: linear-gradient(135deg, #5f7aad, #a8b9d4);\n}\n\n.mvf-box.vision {\n  background: linear-gradient(135deg, #4abee8, #d4e8f2);\n}\n\n.mvf-box.focus {\n  background: linear-gradient(135deg, #d8e6f2, #5a94e8);\n}\n\n.mvf-box.contribution {\n  background: linear-gradient(135deg, #8670d4, #e4dff2);\n}\n\n/* Login panel: first on mobile */\n.right-login-box {\n  order: 1;\n  flex: 1;\n  padding: clamp(1.5rem, 5vw, 3rem) clamp(1.25rem, 4vw, 2rem);\n  background: linear-gradient(145deg, #7eb8d4 0%, #6aa8c8 40%, #5c96b8 100%);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: stretch;\n  border-radius: 12px 12px 0 0;\n  box-shadow: 0 4px 28px rgba(28, 60, 80, 0.18);\n  min-width: 0;\n  animation: fadeIn 1.2s ease-in;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.login-title {\n  font-size: clamp(1.5rem, 5vw, 2.25rem);\n  margin: 0 0 clamp(1.25rem, 3vw, 2rem);\n  color: #0c2f3d;\n  font-weight: 700;\n  text-align: center;\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.login-form {\n  width: 100%;\n  max-width: 380px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  box-sizing: border-box;\n}\n\n.login-form input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.login-form .login-button {\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin-left: 0;\n}\n\n.login-form label {\n  font-weight: 600;\n  margin-bottom: 0.6rem;\n  display: block;\n  color: #2a4150;\n  font-size: clamp(1rem, 2.5vw, 1.25rem);\n}\n\n.login-form .form-field {\n  margin-bottom: 1rem;\n}\n\n.login-form .form-field:last-of-type {\n  margin-bottom: 1.25rem;\n}\n\n.login-form input[type=\"email\"],\n.login-form input[type=\"password\"],\n.login-form input[type=\"text\"] {\n  padding: 0.85rem 1rem;\n  border: 1px solid rgba(12, 47, 61, 0.18);\n  border-radius: 10px;\n  font-size: clamp(1rem, 2.5vw, 1.15rem);\n  background-color: rgba(255, 255, 255, 0.72);\n  color: #1c2d38;\n  box-shadow: inset 0 1px 3px rgba(12, 47, 61, 0.08);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;\n}\n\n.login-form input::placeholder {\n  color: #5a7282;\n}\n\n.login-form input:focus {\n  border-color: rgba(0, 120, 168, 0.55);\n  background-color: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 0 0 3px rgba(0, 136, 198, 0.22);\n  outline: none;\n}\n\n/* Grid stacks input + button in one row so the icon stays centered without transform */\n.password-field {\n  display: grid;\n  grid-template-columns: 1fr;\n  align-items: center;\n  margin-bottom: 0;\n}\n\n.password-field input {\n  grid-column: 1;\n  grid-row: 1;\n  padding-right: 2.75rem;\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n.password-toggle {\n  grid-column: 1;\n  grid-row: 1;\n  justify-self: end;\n  align-self: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2.25rem;\n  height: 2.25rem;\n  margin-right: 0.35rem;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: #0c2f3d;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.password-toggle:hover {\n  background: rgba(12, 47, 61, 0.12);\n  color: #061f28;\n}\n\n.password-toggle:focus-visible {\n  outline: 2px solid #0088c6;\n  outline-offset: 1px;\n}\n\n.login-button {\n  padding: 0.9rem 1.25rem;\n  background: linear-gradient(180deg, #0a7aad 0%, #066892 100%);\n  color: #f0f6f9;\n  border: none;\n  border-radius: 10px;\n  font-size: clamp(1.05rem, 2.5vw, 1.2rem);\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease;\n  box-shadow: 0 4px 16px rgba(6, 60, 82, 0.35);\n  margin-top: 0.25rem;\n}\n\n.login-button:hover {\n  background: linear-gradient(180deg, #096a94 0%, #055a7d 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(6, 60, 82, 0.4);\n}\n\n.login-button:active {\n  transform: translateY(0);\n}\n\n.error-message {\n  color: #c62828;\n  margin-top: -0.35rem;\n  margin-bottom: 0.5rem;\n  font-size: clamp(0.8rem, 2vw, 0.95rem);\n}\n\n.footer-logos {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  margin-top: auto;\n  gap: clamp(1rem, 3vw, 2rem);\n  padding-top: clamp(1rem, 3vw, 2rem);\n}\n\n.footer-logos img {\n  height: clamp(56px, 12vw, 90px);\n  max-width: 45%;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.footer-logos img:hover {\n  transform: scale(1.05);\n}\n\n.forgot-password-link {\n  text-align: right;\n}\n\n.forgot-password-link a {\n  font-size: 1.4rem;\n  color: #005580;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.forgot-password-link a:hover {\n  color: #003f5c;\n  text-decoration: underline;\n}\n\n/* Side-by-side layout on large screens */\n@media (min-width: 960px) {\n  .login-container {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0;\n  }\n\n  .left-card {\n    order: 1;\n    flex: 1;\n    border-radius: 12px 0 0 12px;\n    padding: 2.5rem;\n  }\n\n  .right-login-box {\n    order: 2;\n    flex: 1;\n    max-width: min(520px, 48vw);\n    border-radius: 0 12px 12px 0;\n    align-items: center;\n    box-shadow: -5px 0 30px rgba(0, 0, 0, 0.05);\n  }\n\n  .login-title {\n    text-align: left;\n    align-self: stretch;\n    max-width: 380px;\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
